export default "__VITE_ASSET__c54e2040__"